<script setup>
import { RouterLink, RouterView } from 'vue-router';
import Navbar from '@environment/Navbar.vue';
import { headerHeight } from '@states/HeaderState';
import Footer from '@environment/Footer.vue';
import { footerHeight } from '@states/FooterState';
import BackToTopButton from '@environment/BackToTopButton.vue';
</script>

<template>
  <div class="app" id="app" :style="{ 'margin-top': headerHeight, 'margin-bottom': footerHeight }">
    <Navbar />
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <Footer />
    <BackToTopButton />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
